import * as React from "react";
import { useState } from "react";
import { Card } from "react-bootstrap";
import { useAdminContext } from "../../contexts/AdminContext";
import { Table } from "react-bootstrap";
import { MemberType, UserInfo } from "../../contexts/ContextTypes";
import numberToMoney from "../../utils/numberToMoney";

export default function OwesSummary() {
  const [allUsers, setAllUsers] = useState<Array<UserInfo>>([]);
  const { getTotalUserList } = useAdminContext();
  
  React.useEffect(() => {
    const generateOwesReport = async () => {
      setAllUsers(await getTotalUserList());
    }
    generateOwesReport();
  }, [setAllUsers, getTotalUserList])

  return (
    <Card style={{ minWidth: "44em" }}>
      <Card.Header>
        <>
        <h2>Owes Summary</h2>
        <p>
          We are owed a total of £{
            numberToMoney(
              allUsers
                .map(user => (user.owes === undefined) ? 0 : user.owes)
                .reduce((userOwes, accumulator) => {return (accumulator + userOwes)}, 0)
            )
          } with {
            allUsers.filter(user => user.owes !== undefined && user.owes > 0).length
          } members owing us money.
        </p>
        </>
      </Card.Header>
      <Card.Body className="d-flex justify-content-center row">
          <Table>
            <thead>
              <tr>
                <th className="text-center">Name</th>
                <th className="text-center">Email</th>
                <th className="text-center">Owes</th>
              </tr>
            </thead>
            <tbody>{
                allUsers.filter(user => user.owes !== 0).map((user) => {
                  return (
                    <tr key={user.uid}>
                      <td className="text-center">
                        <>{`${user.firstName} ${user.lastName}`}</>
                        <>
                          {user.memberType === MemberType.trial && (
                            <span className="badge bg-warning text-dark ms-2">TRIAL</span>
                          )}
                        </>
                      </td>
                      <td className="text-center">{user.email}</td>
                      <td className='text-center'>{(user.owes !== undefined) ? ("£" + numberToMoney(user.owes)) : "¯\\_(ツ)_/¯" }</td>
                    </tr>
                  );
                })
            }</tbody>
          </Table>
      </Card.Body>
      <Card.Footer>
      </Card.Footer>
    </Card>
  );
}
